import styled from 'styled-components'
import { colors } from 'Common/constants'

export const Label = styled.small`
    color: ${colors.gray};
    text-transform: uppercase;
    font-weight: bold;
    margin-right: 0.5rem;
`